import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css'

export const pushErrorMessage = (msg, type = "error") => {

  console.log ("pushErrorMessage toast") ;
  toast.error(msg, {
    position: "top-center",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored"
    })
}

export const pushNotification = (msg, type = "info") => {
  toast.info(msg, {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored"
    })
}